import type { UseHttp } from '~/api/interface'

export const fetchIndustryGetAll: UseHttp = (params, option) => {
  return useHttp.get('/api/industry/getAll', params, {
    ...option
  })
}
